import React from 'react';
import { Box } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

export default function AiBusyOverlay({ busy }: { busy: boolean }) {
  if (!busy) return null;
  return (
    <Box sx={{
      position: 'fixed', left: 16, bottom: 16, zIndex: 1400,
      pointerEvents: 'none'
    }}>
      <Box sx={{
        position: 'relative', width: 48, height: 48, borderRadius: '50%',
        backgroundColor: (t)=> t.palette.mode==='light' ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.7)',
        border: (t)=> `1px solid ${t.palette.mode==='light' ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.12)'}`,
        boxShadow: '0 6px 18px rgba(0,0,0,0.18)',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <Box component="img" src="/assets/ai_badge_unitresco.svg" alt="AI" sx={{ width: 22, height: 22 }} />
        <AutoAwesomeIcon sx={{ position: 'absolute', top: -4, left: -4, fontSize: 16, color: 'warning.main', opacity: 0.9, filter: 'drop-shadow(0 0 4px rgba(255,193,7,0.7))', animation: 'ai-sparkle 1.2s ease-in-out infinite' }} />
        <AutoAwesomeIcon sx={{ position: 'absolute', top: -4, right: -4, fontSize: 16, color: 'warning.main', opacity: 0.9, filter: 'drop-shadow(0 0 4px rgba(255,193,7,0.7))', animation: 'ai-sparkle 1.2s ease-in-out infinite', animationDelay: '0.2s' }} />
        <AutoAwesomeIcon sx={{ position: 'absolute', bottom: -6, left: '50%', transform: 'translateX(-50%)', fontSize: 16, color: 'warning.main', opacity: 0.9, filter: 'drop-shadow(0 0 4px rgba(255,193,7,0.7))', animation: 'ai-sparkle 1.2s ease-in-out infinite', animationDelay: '0.4s' }} />
      </Box>
    </Box>
  );
}


